// Custom Colors = [RLGold,RLWhite]
/* social link custom colors {
   circle colors: [RLWhite]
   icon colors: [RLRed]
}*/
export const PROFILE = {
    title: {
        title: 'The Perfect Place RVA',
        color: '',
        font: '',
    },
    TRCLogo: 'colored',
    profilePic:
        'https://res.cloudinary.com/rightlink/image/upload/v1704683196/PerfectPlace/The-Perfect-Place--Logo-A4_taoywp.png',
    background: {
        imageLink: '',
        imageSize: '',
        logoLink: '',
        logoActiveLink: '',
        color: 'background-image: linear-gradient(to left bottom, #ef7a35, #f49454, #f8ac75, #fcc398, #fedabc, #f9e3ca, #f6ebda, #f5f2eb, #eeeee8, #e8e9e5, #e3e5e2, #dfe0df);',
    },
};
export const SOCIAL_LINKS = {
    position: 'top',
    group: [
        {
            name: 'Instagram',
            iconName: 'instagram',
            link: 'https://www.instagram.com/perfectplacerva/',
            color: 'orange',
            inverted: true,
            secondaryColor: '',
            surrounded: 'circular',
            surroundedInColor: true,
        },
    ],
};
// featuredTimerDate formats inclued '2020-02-01T01:02:03' or milliseconds e.g 1580518923000 - documentation here https://github.com/ndresx/react-countdown
// for media as links you must set type as 'item' and mainMedia.type as either 'still, mp4, or other(not implemented yet)'
// using a new Link_group setup
export const LINK_GROUPS = [
    {
        groupName: '',
        groupColor: '',
        groupFont: '',
        group: [
            {
                name: 'Website',
                link: 'https://perfectplacerva.com',
                linkSpaced: true,
                type: 'external',
                typeAction: '',
                internal: false,
                featured: false,
                featuredText: '',
                featuredTimerDate: '',
                featuredTimerText: '',
                featuredColor: '',
                featuredAltStyle: '',
                pinned: true,
                mainMedia: {},
                additionalLinks: [],
                color: 'orange',
                colorOveride: '',
                fontColor: '',
                colored: false,
                buttonColor: '',
                bannerSide: 'left',
                additionalStyle: 'longText',
                modalAlternativeText: {
                    removed: false,
                    text: '',
                },
                bioContent: [],
            },
            {
                name: 'Event Venue & Calendar',
                link: 'https://www.perfectplacerva.com/venue',
                linkSpaced: true,
                type: 'external',
                typeAction: '',
                internal: false,
                featured: false,
                featuredText: '',
                featuredTimerDate: '',
                featuredTimerText: '',
                featuredColor: '',
                featuredAltStyle: '',
                pinned: true,
                mainMedia: {},
                additionalLinks: [],
                color: 'orange',
                colorOveride: '',
                fontColor: '',
                colored: false,
                buttonColor: '',
                bannerSide: 'left',
                additionalStyle: 'longText',
                modalAlternativeText: {
                    removed: false,
                    text: '',
                },
                bioContent: [],
            },
            {
                name: 'Call Now for a Quote!',
                link: 'tel:8047230667',
                linkSpaced: true,
                type: 'external',
                typeAction: '',
                internal: false,
                featured: false,
                featuredText: '',
                featuredTimerDate: '',
                featuredTimerText: '',
                featuredColor: '',
                featuredAltStyle: '',
                pinned: true,
                mainMedia: {},
                additionalLinks: [],
                color: 'orange',
                colorOveride: '',
                fontColor: '',
                colored: false,
                buttonColor: '',
                bannerSide: 'left',
                additionalStyle: 'longText',
                modalAlternativeText: {
                    removed: false,
                    text: '',
                },
                bioContent: [],
            },
            {
                name: 'Request a Quote Online!',
                link: 'https://www.perfectplacerva.com/request-a-quote',
                linkSpaced: true,
                type: 'external',
                typeAction: '',
                internal: false,
                featured: false,
                featuredText: '',
                featuredTimerDate: '',
                featuredTimerText: '',
                featuredColor: '',
                featuredAltStyle: '',
                pinned: true,
                mainMedia: {},
                additionalLinks: [],
                color: 'orange',
                colorOveride: '',
                fontColor: '',
                colored: false,
                buttonColor: '',
                bannerSide: 'left',
                additionalStyle: 'longText',
                modalAlternativeText: {
                    removed: false,
                    text: '',
                },
                bioContent: [],
            },
            {
                name: 'Request a Venue Tour!',
                link: 'https://www.perfectplacerva.com/request-a-tour',
                linkSpaced: true,
                type: 'external',
                typeAction: '',
                internal: false,
                featured: false,
                featuredText: '',
                featuredTimerDate: '',
                featuredTimerText: '',
                featuredColor: '',
                featuredAltStyle: '',
                pinned: true,
                mainMedia: {},
                additionalLinks: [],
                color: 'orange',
                colorOveride: '',
                fontColor: '',
                colored: false,
                buttonColor: '',
                bannerSide: 'left',
                additionalStyle: 'longText',
                modalAlternativeText: {
                    removed: false,
                    text: '',
                },
                bioContent: [],
            },
            {
                name: 'Event Rental Prices!',
                link: 'https://www.perfectplacerva.com/services',
                linkSpaced: true,
                type: 'external',
                typeAction: '',
                internal: false,
                featured: false,
                featuredText: '',
                featuredTimerDate: '',
                featuredTimerText: '',
                featuredColor: '',
                featuredAltStyle: '',
                pinned: true,
                mainMedia: {},
                additionalLinks: [],
                color: 'orange',
                colorOveride: '',
                fontColor: '',
                colored: false,
                buttonColor: '',
                bannerSide: 'left',
                additionalStyle: 'longText',
                modalAlternativeText: {
                    removed: false,
                    text: '',
                },
                bioContent: [],
            },
            {
                name: 'Slideshow',
                link: 'https://www.perfectplacerva.com/gallery',
                linkSpaced: true,
                type: 'slideshow',
                typeAction: '',
                internal: false,
                featured: false,
                featuredText: '',
                featuredTimerDate: '',
                featuredTimerText: '',
                featuredColor: '',
                featuredAltStyle: '',
                pinned: true,
                mainMedia: {
                    type: 'slideshow',
                    speed: 1000,
                    mediaText: 'We Also Do Ballons!',
                    collection: [
                        'https://res.cloudinary.com/rightlink/image/upload/v1668302687/PerfectPlace/My_project-2_10_wsjgxj.png',
                        'https://res.cloudinary.com/rightlink/image/upload/v1668189575/PerfectPlace/IMG_6684_rdwdp3.jpg',
                        'https://res.cloudinary.com/rightlink/image/upload/v1668267327/PerfectPlace/My_project-2_yrrv1m.png',
                        'https://res.cloudinary.com/rightlink/image/upload/v1668190219/PerfectPlace/IMG_7448_p3rgex.jpg',
                        'https://res.cloudinary.com/rightlink/image/upload/v1668267883/PerfectPlace/My_project-2_1_wxzqzi.png',
                        'https://res.cloudinary.com/rightlink/image/upload/v1668271341/PerfectPlace/My_project-2_2_g5dc4l.png',
                        'https://res.cloudinary.com/rightlink/image/upload/v1668302681/PerfectPlace/My_project-2_11_wrlk5a.png',
                        'https://res.cloudinary.com/rightlink/image/upload/v1668271788/PerfectPlace/My_project-2_3_ddsieb.png',
                        'https://res.cloudinary.com/rightlink/image/upload/v1668271788/PerfectPlace/My_project-2_5_vmhdkr.png',
                        'https://res.cloudinary.com/rightlink/image/upload/v1668272010/PerfectPlace/My_project-2_6_myzfq7.png',
                        'https://res.cloudinary.com/rightlink/image/upload/v1668271788/PerfectPlace/My_project-2_4_ssryoj.png',
                        'https://res.cloudinary.com/rightlink/image/upload/v1668272010/PerfectPlace/My_project-2_7_nv5jay.png',
                        'https://res.cloudinary.com/rightlink/image/upload/v1668272215/PerfectPlace/My_project-2_9_ovewkg.png',
                    ],
                },
                additionalLinks: [],
                color: 'orange',
                colorOveride: '',
                fontColor: '',
                colored: false,
                buttonColor: '',
                bannerSide: 'left',
                additionalStyle: 'longText',
                modalAlternativeText: {
                    removed: false,
                    text: '',
                },
                bioContent: [],
            },
        ],
    },
];
